<template>
<svg width="1.5rem" height="1.5rem" 
    viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000000">
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier"> <g id="Menu / Close_SM"> 
            <path id="Vector" d="M16 16L12 12M12 12L8 8M12 12L16 8M12 12L8 16" stroke="#ffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            </path> 
        </g> 
    </g>
</svg>
</template>